import React, { useState, useEffect, useRef } from "react";
import { HeadersAuth } from "../funciones_utiles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { manejarError } from "../manejo_errores";
import { Button, Checkbox, Col, Form, Popover, Row, Select, Tabs } from "antd";
import { useMediaQuery } from "react-responsive";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { TablaCompleta } from "../tablas/tabla_simple";
import { InfoCircleOutlined, PlusCircleOutlined, PlusOutlined, SmileOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import EmojiPicker from "emoji-picker-react";
import { SelectCustom } from "../componentes/selectComponent";
import axios from "axios";
import moment from "moment";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";

export const NotificacionesSistema = ({ id_asociacion, setAlerta, onLimpiarCampos, setOnLimpiarCampos }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const MySwal = withReactContent(Swal);
  const quillTitleRef = useRef(null);
  const quillBodyRef = useRef(null);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    title: "",
    body: "",
    id_tipo_seccion_web: "",
    id_tipo_disparador: "",
    id_tipo_screen: "",
  });
  const [notificacionesSistema, setNotificacionesSistema] = useState([]);
  const [tiposDisparadores, setTiposDisparadores] = useState([]);
  const [tiposScreen, setTiposScreen] = useState([]);
  const [tiposSeccionWeb, setTiposSeccionWeb] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [placeholdersDisponibles, setPlaceholdersDisponibles] = useState([]);


  useEffect(() => {
    fetchNotificacionesSistema();
  }, [id_asociacion, tempDatosFormulario.id_tipo_seccion_web])

  // Obtener notificaciones puntuales
  const fetchNotificacionesSistema = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-sistema/${id_asociacion}?id_seccion=${tempDatosFormulario.id_tipo_seccion_web}`, 
        HeadersAuth
      );
      // console.log("response de datos", response.data)
      const { notificacionesSistema, tiposDisparadores, tiposScreen, tiposSeccionWeb } = response.data;

      setNotificacionesSistema(notificacionesSistema);
      setTiposDisparadores(tiposDisparadores);
      setTiposScreen(tiposScreen);
      setTiposSeccionWeb(tiposSeccionWeb);

    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  }

  // Insertar emoji en Quill
  const insertarEmojiEnQuill = (quillRef, emojiData) => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const emoji = emojiData.emoji; // emoji-picker-react
    const selection = quill.getSelection();
    const cursorPos = selection?.index ?? quill.getLength();

    quill.insertText(cursorPos, emoji);
    quill.setSelection(cursorPos + emoji.length);
  };

  const insertarPlaceholderEnQuill = (quillRef, key) => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const placeholder = `{${key}}`;  // 🔥 Insertamos con llaves  

    const cursor = quill.getSelection()?.index ?? quill.getLength();
    quill.insertText(cursor, placeholder);
    quill.setSelection(cursor + placeholder.length);
  };

  const fetchPlaceHolder = async () => {
    try {
      const seccion = tiposSeccionWeb.find(
        s => s.id === Number(tempDatosFormulario.id_tipo_seccion_web)
      )?.codigo;

      if (!seccion) return;

      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-sistema/placeholders/${seccion}?disparador=${tempDatosFormulario.id_tipo_disparador}`,
        HeadersAuth
      )
      // console.log("response de placeholders", response.data)
      setPlaceholdersDisponibles(response.data.placeholders)
    } catch (error) {
      setPlaceholdersDisponibles([]);
    }
  }

  useEffect(() => {
    if (!tempDatosFormulario.id_tipo_disparador) return;
    // console.log("fetch de placeholders por disparador")
    fetchPlaceHolder();
  }, [tempDatosFormulario.id_tipo_disparador]);

  useEffect(() => {
    if (!tempDatosFormulario.id_tipo_seccion_web) return;

    fetchPlaceHolder();
  }, [tempDatosFormulario.id_tipo_seccion_web]);

  // Convertir Quill a texto plano
  const quillToPlainText = (html) => {
    if (!html) return "";
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return (temp.textContent || temp.innerText || "").trim();
  };

  // Guardar notificación de sistema
  const guardarNotificacion = async () => {
    try {
      const payload = {
        title: quillToPlainText(tempDatosFormulario.title),             
        body: quillToPlainText(tempDatosFormulario.body),                
        id_tipo_seccion_web: tempDatosFormulario.id_tipo_seccion_web,
        id_tipo_disparador: tempDatosFormulario.id_tipo_disparador,
        id_tipo_screen: tempDatosFormulario.id_tipo_screen,
      };
      // console.log("lo que se envía:", payload)
      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-sistema/guardar`,
        {
          ...payload,
          id_asociacion: id_asociacion,
        },
        HeadersAuth
      );

      manejarAlertas("success", "Notificación guardada con éxito.");
      await fetchNotificacionesSistema();
      limpiarCampos();
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const cargarParaEditar = (notif) => {
    setEditandoId(notif.id);
    
    setTempDatosFormulario({
      title: notif.title,
      body: notif.body,
      id_tipo_seccion_web: notif.id_tipo_seccion_web,
      id_tipo_disparador: notif.id_tipo_disparador,
      id_tipo_screen: notif.id_tipo_screen
    });

    // Mover scroll al formulario (opcional)
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const actualizarNotificacion = async () => {
    try {
      const payload = {
        title: quillToPlainText(tempDatosFormulario.title),
        body: quillToPlainText(tempDatosFormulario.body),
        id_tipo_seccion_web: tempDatosFormulario.id_tipo_seccion_web,
        id_tipo_disparador: tempDatosFormulario.id_tipo_disparador,
        id_tipo_screen: tempDatosFormulario.id_tipo_screen,
      };

      const response = await axios.put(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-sistema/editar/${editandoId}`,
        payload,
        HeadersAuth
      );

      manejarAlertas("success", "Notificación actualizada con éxito.");

      await fetchNotificacionesSistema();
      limpiarCampos();
      setEditandoId(null);

    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  // Eliminar notificaciones
  const handleEliminarNotificaciones = async (id) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_DOMINIO}/notificaciones-sistema/eliminar/${id}`,
            HeadersAuth
          );
          fetchNotificacionesSistema();
          manejarAlertas("success", "Notificación eliminada con éxito.");
        } catch (error) {
          manejarAlertas("error", manejarError(error));
        }
      }
    })
  }

  const elScroll = { x: 0 };
  const columnsSistema = [
    {
      title: "SECCIÓN-WEB",
      key: "seccionWeb",
      align: "left",
      width: "120px",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.seccionWeb?.descripcion}
        </div>
      )
    },
    {
      title: "MOTIVO",
      key: "disparador",
      align: "left",
      width: "80px",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.disparador?.descripcion}
        </div>
      )
    },
    {
      title: "SECCIÓN-APP",
      key: "seccionApp",
      align: "left",
      width: "120px",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.screenApp?.descripcion}
        </div>
      )
    },
    {
      title: "TÍTULO",
      key: "title",
      align: "left",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.title}
        </div>
      )
    },
    {
      title: "CUERPO",
      key: "body",
      align: "left",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.body}
        </div>
      )
    },
    {
      title: "OPCIONES",
      key: "opciones",
      align: "center",
      width: "80px",
      render: (_, record) => (
        <>
          <FaRegEdit
            onClick={() => cargarParaEditar(record)}
            className="iconos-tablas"
            style={{ color: "blue", cursor: "pointer", marginRight: 5 }}
          />
          <FaRegTrashAlt
            onClick={() => handleEliminarNotificaciones(record.id)}
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
          />
        </>
      )
    },
  ];

  useEffect(() => {
    if (!onLimpiarCampos) return;
    limpiarCampos();

    setOnLimpiarCampos(false);

  }, [onLimpiarCampos, setOnLimpiarCampos]);

  const limpiarCampos = () => {
    setTempDatosFormulario({
      title: "",
      body: "",
      id_tipo_seccion_web: "",
      id_tipo_disparador: "",
      id_tipo_screen: "",
    });
    setMostrarBotonLimpiar(false)
    setEditandoId(null);
  };

  useEffect(() => {
    if (tempDatosFormulario.id_tipo_seccion_web === "") {
      setTempDatosFormulario(prev => ({
        ...prev,
        id_tipo_disparador: "",
        id_tipo_screen: ""
      }));
    }
  }, [tempDatosFormulario.id_tipo_seccion_web]);

  useEffect(() => {
    if (tempDatosFormulario.id_tipo_disparador === "") {
      setTempDatosFormulario(prev => ({
        ...prev,
        id_tipo_screen: ""
      }));
    }
  }, [tempDatosFormulario.id_tipo_disparador]);

  const quillModulesSinToolbar = {
    toolbar: false, 
  };

  const quillFormatsVacios = []; 

  return (
    <>
      <Form
        layout="vertical"
        onFinish={editandoId ? actualizarNotificacion : guardarNotificacion}
      >
        <Row className="rowAdmin" gutter={16} align="center">
          <Col xs={24} sm={8} style={{ width: "100%" }}>
            <SelectCustom
              idCampo={"id_tipo_seccion_web"}
              textoOpciones={"descripcion"}
              arrayOpciones={tiposSeccionWeb.length > 0 ? tiposSeccionWeb : []}
              nombreCampo={"Elegí la sección de la web:"}
              elPlaceholder={"Seleccioná una opción"}
              required={true}
              onChange={(e) =>
                setTempDatosFormulario(prev => ({
                  ...prev,
                  id_tipo_seccion_web: e.target.value,
                }))
              }
              elValue={tempDatosFormulario.id_tipo_seccion_web}
              disabled={!tiposSeccionWeb}
            />
          </Col>
          <Col xs={24} sm={8} style={{ width: "100%" }}>
            <SelectCustom
              idCampo={"id_tipo_disparador"}
              textoOpciones={"descripcion"}
              arrayOpciones={tiposDisparadores.length > 0 ? tiposDisparadores : []}
              nombreCampo={"Elegí el motivo:"}
              elPlaceholder={"Seleccioná una opción"}
              required={true}
              onChange={(e) =>
                setTempDatosFormulario(prev => ({
                  ...prev,
                  id_tipo_disparador: e.target.value,
                }))
              }
              elValue={tempDatosFormulario.id_tipo_disparador}
              disabled={!tempDatosFormulario.id_tipo_seccion_web}
            />
          </Col>
          <Col xs={24} sm={8} style={{ width: "100%" }}>
            <SelectCustom
              idCampo={"id_tipo_screen"}
              textoOpciones={"descripcion"}
              arrayOpciones={tiposScreen.length > 0 ? tiposScreen : []}
              nombreCampo={"Elegí la sección de la app:"}
              elPlaceholder={"Seleccioná una opción"}
              required={true}
              onChange={(e) =>
                setTempDatosFormulario(prev => ({
                  ...prev,
                  id_tipo_screen: e.target.value,
                }))
              }
              elValue={tempDatosFormulario.id_tipo_screen}
              disabled={!tempDatosFormulario.id_tipo_disparador}
            />
          </Col>
        </Row>
        {
          tempDatosFormulario.id_tipo_seccion_web && 
          tempDatosFormulario.id_tipo_disparador && 
          tempDatosFormulario.id_tipo_screen &&
          (
          <Row className="rowAdmin" gutter={16} align="center">
            <Col xs={24} sm={12} style={{ width: "100%", marginTop: 10 }}>
              <Form.Item style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <p className="nombre-campo">Título *</p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      width: "100%",
                    }}
                  >
                    {/* Editor */}
                    <div
                      style={{
                        width: "100%",
                        border: "1px solid #d9d9d9",
                        borderRadius: 10,
                        padding: 8,
                        backgroundColor: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                      }}
                    >
                      {/* Contenedor del editor y el botón */}
                      <div style={{ display: "flex", width: "100%" }}>
                        
                        {/* ReactQuill redondeado */}
                        <div style={{ flex: 1 }}>
                          <ReactQuill
                            ref={quillTitleRef /* o quillBodyRef */}
                            className="quill-rounded"
                            theme="snow"
                            value={tempDatosFormulario.title}
                            onChange={(value) =>
                              setTempDatosFormulario(prev => ({ ...prev, title: value }))
                            }
                            modules={quillModulesSinToolbar}
                            formats={quillFormatsVacios}
                            placeholder="Escribí el título…"
                            style={{
                              width: "100%",
                            }}
                          />
                        </div>

                        {/* Botón emoji dentro del recuadro */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Popover
                            trigger="click"
                            placement="bottom"
                            content={
                              <EmojiPicker
                                emojiStyle="google"
                              
                                onEmojiClick={(emojiData) =>
                                  insertarEmojiEnQuill(quillTitleRef, emojiData)
                                }
                              />
                            }
                          >
                            <Button
                              type="text"
                              title="Emojis"
                              icon={<SmileOutlined style={{ width: 20, height: 20, fontWeight: 100, color: "#BA1721" }}/>}
                              style={{
                                alignSelf: "center",
                                marginLeft: 6,
                              }}
                            />
                          </Popover>
                          <Popover
                            trigger="click"
                            placement="bottom"
                            content={
                              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                {placeholdersDisponibles.length > 0 ? (
                                  placeholdersDisponibles.map((p) => (
                                    <Button
                                      style={{
                                        width: "100%",
                                      }}
                                      key={p.key}
                                      size="small"
                                      onClick={() => insertarPlaceholderEnQuill(quillTitleRef, p.key)}
                                    >
                                      <p
                                        style={{
                                          fontSize: 16,
                                          fontWeight: 400,
                                        }}
                                      >
                                        {p.label}
                                      </p>
                                    </Button>
                                  ))
                                ) : (
                                  <p
                                    style={{
                                      fontSize: 14,
                                      fontWeight: 400,
                                    }}
                                  >
                                    No hay variables disponibles.
                                  </p>
                                )}
                              </div>
                            }
                          >
                            <Button
                              type="text"
                              title="Variables"
                              icon={<PlusCircleOutlined style={{ width: 20, height: 20, fontWeight: 100, color: "#BA1721" }} />}
                              style={{
                                alignSelf: "center",
                                marginLeft: 6,
                              }}
                            >
                            </Button>
                          </Popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} style={{ width: "100%", marginTop: 10 }}>
              <Form.Item style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <p className="nombre-campo">Cuerpo de la notificación *</p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      width: "100%",
                    }}
                  >
                    {/* Editor */}
                    <div
                      style={{
                        width: "100%",
                        border: "1px solid #d9d9d9",
                        borderRadius: 10,
                        padding: 8,
                        backgroundColor: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                      }}
                    >
                      {/* Contenedor del editor y el botón */}
                      <div style={{ display: "flex", width: "100%" }}>
                        
                        {/* ReactQuill redondeado */}
                        <div style={{ flex: 1 }}>
                          <ReactQuill
                            ref={quillBodyRef}
                            className="quill-rounded"
                            theme="snow"
                            value={tempDatosFormulario.body}
                            onChange={(value) =>
                              setTempDatosFormulario(prev => ({ ...prev, body: value }))
                            }
                            modules={quillModulesSinToolbar}
                            formats={quillFormatsVacios}
                            placeholder="Escribí el cuerpo de la notificación…"
                            style={{
                              width: "100%",
                            }}
                          />
                        </div>

                        {/* Botón emoji dentro del recuadro */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Popover
                            trigger="click"
                            placement="bottom"
                            content={
                              <EmojiPicker
                                emojiStyle="google"
                              
                                onEmojiClick={(emojiData) =>
                                  insertarEmojiEnQuill(quillBodyRef, emojiData)
                                }
                              />
                            }
                          >
                            <Button
                              type="text"
                              title="Emojis"
                              icon={<SmileOutlined style={{ width: 20, height: 20, fontWeight: 100, color: "#BA1721" }}/>}
                              style={{
                                alignSelf: "center",
                                marginLeft: 6,
                              }}
                            />
                          </Popover>
                          <Popover
                            trigger="click"
                            placement="bottom"
                            content={
                              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                {placeholdersDisponibles.length > 0 ? (
                                  placeholdersDisponibles.map((p) => (
                                    <Button
                                      style={{
                                        width: "100%",
                                      }}
                                      key={p.key}
                                      size="small"
                                      onClick={() => insertarPlaceholderEnQuill(quillBodyRef, p.key)}
                                    >
                                      <p
                                        style={{
                                          fontSize: 16,
                                          fontWeight: 400,
                                        }}
                                      >
                                        {p.label}
                                      </p>
                                    </Button>
                                  ))
                                ) : (
                                  <p
                                    style={{
                                      fontSize: 14,
                                      fontWeight: 400,
                                    }}
                                  >
                                    No hay variables disponibles.
                                  </p>
                                )}
                              </div>
                            }
                          >
                            <Button
                              type="text"
                              title="Variables"
                              icon={<PlusCircleOutlined style={{ width: 20, height: 20, fontWeight: 100, color: "#BA1721" }} />}
                              style={{
                                alignSelf: "center",
                                marginLeft: 6,
                              }}
                            >
                            </Button>
                          </Popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row gutter={16} align="middle">
          <Col xs={24} sm={24}className="botonesResponsive"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            marginTop: 20
          }}>
            <Button
              type="primary"
              htmlType="submit"
              className="boton-principal-noti"
              style={{
                width: "50%",
              }}
            >
              {editandoId ? "Actualizar notificación" : "Guardar notificación"}
            </Button>
          </Col>
        </Row>
      </Form>
      {/* Tabla de notificaciones */}
      <div
        className="botonDescargar"
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "flex-end",
          padding:"0 16px"
        }}
      >
        {" "}
        <br></br>
        <TablaCompleta
          tituloPDF={"notificaciones"}
          elScroll={elScroll}
          columns={columnsSistema}
          fetchDatos={notificacionesSistema.length > 0 ? notificacionesSistema : []}
          rowKey={"id"}
          tituloBanner={"Notificaciones"}
          idAsociacion={id_asociacion}
          customMargin={"-0.1em"}
          // mostrarBoton={false}
          esNotificaciones={true}
          gestionTabla={
            <Row style={{ gap: "10px" }}>
              {editandoId !== null && !mostrarBotonLimpiar && (
                <BotonPrincipal
                  texto="Nueva notificación"
                  onClick={limpiarCampos}
                />
              )}
            </Row>
          }
        />
      </div>
    </>
  )
}